import RoundedImage from '../../../components/RoundedImage';
import { useState } from 'react';
import styles from './ProjectOwnerAndReceiver.module.less';

const getUserDefaultImage = (user) => {
    const icon = user.organizationNumber ? 'fa-duotone fa-user-group' : 'fa-solid fa-user';
    return (
        <span className={styles.profileImageFA}>
            <i className={`fa-lg ${icon}`} />
        </span>
    );
};
export const ProfileImage = ({ projectUser }) => {
    const [hasImage, setHasImage] = useState(!!projectUser.imageSource);
    if (hasImage) {
        return (
            <div className={styles.profileImage}>
                <RoundedImage
                    src={projectUser.imageSource}
                    alt={`${projectUser.name} sitt profilbilde`}
                    size={'40px'}
                    showDefault={false}
                    loading={'lazy'}
                    className={styles.profileImage}
                    onError={() => setHasImage(false)}
                />
            </div>
        );
    }
    return getUserDefaultImage(projectUser);
};
